import React, { useEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux'
import { Row, Col, ButtonGroup, Button, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { Redirect, Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Utils } from '../../../services/';
import PageTitle from '../../../components/PageTitle/PageTitle';
import { loadPeriod, deletePeriod } from '../../../redux/modules/periods';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';


const PeriodDelete = () => {
    const { periodId }  = useParams();
    const dispatch     = useDispatch();
    const { t }        = useTranslation();
    const default_lang = Utils.default_lang();

    const { period, isLoading, periodSuccessfullyDeleted } = useSelector(state => state.periods);

    useEffect(() => {
        dispatch(loadPeriod(periodId));
    }, []);

    const submit = (periodId) => {
        dispatch(deletePeriod(periodId));
    };

    let title = <span>{t("periods.period", {count: 42})}</span>;
    if (period)
        title = (
            <span>
                {period.name[default_lang]}
                <small> |&nbsp;{t('periods.confirm_delete', { name: period.name[default_lang] })}</small>
            </span>
        );

    const actions =
        <div>
            <ButtonGroup>
                <Button tag={Link} to="/periods" color="warning" size="sm">
                    <i className="fa fa-arrow-left"></i>&nbsp;{t("common.back")}
                </Button>
            </ButtonGroup>
        </div>

    return (
        <div className="PeriodDelete">
            <PageTitle icon="sun-o" title={title} actions={actions} />

            {periodSuccessfullyDeleted &&
                <Redirect to="/periods" />
            }

            {period &&
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle><i className="fa fa-warning"></i>&nbsp;{t('periods.confirm_delete')}</CardTitle>
                                <CardText tag="div">
                                    <div><b>{t("periods.name")}</b>: {period.name[default_lang]}</div>
                                    <div><b>{t("periods.active_from")}</b>: {moment(period.start_at).format('LLL')}</div>
                                    <div><b>{t("periods.active_until")}</b>: {moment(period.stop_at).format('LLL')}</div>
                                    <Row>
                                        <Col className="text-center">
                                            <Button tag={Link} to="/periods" color="warning">
                                                <i className="fa fa-arrow-left"></i>&nbsp;{t('common.cancel')}
                                            </Button>&nbsp;
                                            <Button color="danger" onClick={(e) => submit(period.id)} disabled={isLoading}>
                                                {isLoading ?
                                                    <span>
                                                        &nbsp;<i className="fa fa-spinner fa-spin"></i>
                                                    </span>
                                                    :
                                                    <span>
                                                        <i className="fa fa-trash"></i>&nbsp;
                                                        {t('common.delete')}
                                                    </span>
                                                }
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardText>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            }
        </div>
    );
}

export default PeriodDelete;
